import React from 'react';
import { Navigate } from 'react-router-dom';
import type { RolUsuario } from '../../api/Objetos';
import { useAuth } from '../providers/AuthProvider';

export function RequireRole(props: { allow: RolUsuario[]; children: React.ReactNode }) {
  const auth = useAuth();

  if (!auth.isAuthenticated) {
    return <Navigate to="/administracion/iniciar-sesion" replace />;
  }

  if (!auth.rol || !props.allow.includes(auth.rol)) {
    return <Navigate to="/administracion" replace />;
  }

  return <>{props.children}</>;
}
